import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./ServicePage.css";
import { Helmet } from "react-helmet";
import "../ImportExport/ServicePages.css";
// PatentRegistration.jsx


const PatentRegistration = () => {
  
 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  return (
    <div className="service-page">

      <Helmet>
        <title>
          Patent Registration Service in India | Protect Your Invention
        </title>

        <meta
          name="description"
          content="Protect your innovative product or process with Patent Registration in India. Secure legal rights for your invention with expert patent filing assistance."
        />

        <meta
          name="keywords"
          content="Patent Registration, Patent Filing India, Invention Protection, Patent Certificate, Intellectual Property Rights, Patent Application"
        />
      </Helmet>

      {/* HERO */}
      <section className="service-hero">
        <h1>Patent Registration Service</h1>

        <p>
          Protect Your Innovative Ideas, Products & Technologies Legally
        </p>
         <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>

        <div className="card">
          <p>
            Patent Registration provides exclusive legal rights over a new
            invention, product, technology, or process. It prevents others from
            making, using, selling, or copying your invention without permission.
          </p>

          <p>
            A patent is granted only when the invention is unique, innovative,
            and capable of industrial application.
          </p>
        </div>
      </section>

      {/* WHAT IT PROTECTS */}
      <section className="service-section">
        <h2>What Does Patent Protect?</h2>

        <div className="service-grid-box">

          <div className="card">
            Innovative Products
          </div>

          <div className="card">
            New Technologies
          </div>

          <div className="card">
            Industrial Processes
          </div>

          <div className="card">
            Mechanical Inventions
          </div>

          <div className="card">
            Software-related Innovations
          </div>

          <div className="card">
            Scientific Developments
          </div>

        </div>
      </section>

      {/* CONDITIONS */}
      <section className="service-section">
        <h2>Conditions for Patent Registration</h2>

        <div className="service-grid-box">

          <div className="card">
            Must Be New / Unique
          </div>

          <div className="card">
            Must Involve Innovation
          </div>

          <div className="card">
            Must Be Industrially Applicable
          </div>

        </div>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Patent Registration</h2>

        <div className="service-grid-box">

          <div className="card">
            ✔ Exclusive rights over invention
          </div>

          <div className="card">
            ✔ Prevents unauthorized copying
          </div>

          <div className="card">
            ✔ Increases business value
          </div>

          <div className="card">
            ✔ Helps attract investors
          </div>

          <div className="card">
            ✔ Creates competitive advantage
          </div>

          <div className="card">
            ✔ Legal protection for innovation
          </div>

        </div>
      </section>

      {/* VALIDITY */}
      <section className="service-section">
        <h2>Patent Validity</h2>

        <div className="card">
          <p>
            A granted patent remains valid for{" "}
            <strong>20 years</strong> from the filing date, subject to renewal
            fees and legal compliance.
          </p>
        </div>
      </section>

      {/* WHO SHOULD APPLY */}
      <section className="service-section">
        <h2>Who Should Apply for Patent?</h2>

        <div className="service-grid-box">

          <div className="card">
            Innovators
          </div>

          <div className="card">
            Tech Startups
          </div>

          <div className="card">
            Researchers
          </div>

          <div className="card">
            Engineers
          </div>

          <div className="card">
            Manufacturers
          </div>

          <div className="card">
            Product Developers
          </div>

        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>

        <div className="service-grid-box">

          <div className="card">
            PAN & Aadhaar Card
          </div>

          <div className="card">
            Invention Description
          </div>

          <div className="card">
            Technical Drawings
          </div>

          <div className="card">
            Prototype Details (if available)
          </div>

          <div className="card">
            Applicant Details
          </div>

          <div className="card">
            Business Proof (if applicable)
          </div>

        </div>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>Patent Registration Process</h2>

        <div className="service-grid-box">

          <div className="card">
            Patent Search & Analysis
          </div>

          <div className="card">
            Drafting Patent Specification
          </div>

          <div className="card">
            Patent Application Filing
          </div>

          <div className="card">
            Examination by Patent Office
          </div>

          <div className="card">
            Objection Handling (if any)
          </div>

          <div className="card">
            Patent Grant Certificate
          </div>

        </div>
      </section>

      {/* OUR SERVICES */}
      <section className="service-section">
        <h2>Our Patent Services Include</h2>

        <div className="card">
          <ul>
            <li>Patentability search & consultation</li>
            <li>Drafting of patent specifications</li>
            <li>Patent filing & documentation</li>
            <li>Response to examination objections</li>
            <li>Patent prosecution support</li>
            <li>Complete end-to-end assistance</li>
          </ul>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>

        <div className="card">
          <ul>
            <li>✔ Experienced patent professionals</li>
            <li>✔ Strong technical & legal expertise</li>
            <li>✔ Accurate documentation support</li>
            <li>✔ Affordable pricing</li>
            <li>✔ End-to-end patent assistance</li>
          </ul>
        </div>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Protect Your Innovation Today</h2>

        <p>
          Secure exclusive legal rights for your invention with expert patent
          registration services.
        </p>

        <button>Apply for Patent</button>
      </section> */}
          <div className="cta" ref={contactRef}>
             <h2>Protect Your Innovation Today</h2>
               <p>
          Secure exclusive legal rights for your invention with expert patent
          registration services.
        </p>
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>


    </div>
  );
};

export default PatentRegistration;